import {
  GET_AMENITY,
  GET_CONFIGURATION,
  GET_INSENTIVE_TYPE,
  GET_PROPERTY_TYPE,
  MASTER_ERROR,
  MASTER_LIST,
  CREATE_MASTER,
  GET_FOLLOWUP,
  GET_FOLLOWUP_STATUS,
  CITY_LIST,
  PAYMENT_TYPE,
  GET_ETHNICITY
} from "../types";
import masterService from "../service/masterService";
import strings from "translate/language";
import { errorToast, unAuthorizedError } from "utils/httpClient";
import { MasterTypeHelper } from "utils/constants";
export const getPropertyType = () => async (dispatch) => {
  try {
    const res = await masterService.getMasterList({
      type: MasterTypeHelper.propertyType,
    });
    if (res.data.status === 200) {
      dispatch({
        type: GET_PROPERTY_TYPE,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_PROPERTY_TYPE,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const createMaster = (item) => async (dispatch) => {
  try {
    const res = await masterService.createMaster(item);
    if (res.data.status === 200) {
      dispatch({
        type: CREATE_MASTER,
        payload: res.data,
      });
    } else {
      errorToast(res.data.message);
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getConfiguration = () => async (dispatch) => {
  try {
    const res = await masterService.getMasterList({
      type: MasterTypeHelper.propertyConfiguration,
    });
    if (res.data.status === 200) {
      dispatch({
        type: GET_CONFIGURATION,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_CONFIGURATION,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getAmenity = () => async (dispatch) => {
  try {
    const res = await masterService.getMasterList({
      type: MasterTypeHelper.propertyAmenity,
    });
    if (res.data.status === 200) {
      dispatch({
        type: GET_AMENITY,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_AMENITY,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getInsentiveType = () => async (dispatch) => {
  try {
    const res = await masterService.getMasterList({
      type: MasterTypeHelper.insentiveType,
    });
    if (res.data.status === 200) {
      dispatch({
        type: GET_INSENTIVE_TYPE,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_INSENTIVE_TYPE,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getFollowupStatus = () => async (dispatch) => {
  try {
    const res = await masterService.getMasterList({
      type: MasterTypeHelper.followupStatus,
    });
    if (res.data.status === 200) {
      dispatch({
        type: GET_FOLLOWUP_STATUS,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_FOLLOWUP_STATUS,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getFollowupLead = () => async (dispatch) => {
  try {
    const res = await masterService.getMasterList({
      type: MasterTypeHelper.leadFollowup,
    });
    if (res.data.status === 200) {
      dispatch({
        type: GET_FOLLOWUP,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_FOLLOWUP,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};

export const getMasterList = (item) => async (dispatch) => {
  try {
    const res = await masterService.getMasterList(item);
    if (res.data.status === 200) {
      dispatch({
        type: MASTER_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: MASTER_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};
export const getCityList = (item) => async (dispatch) => {
  try {
    const res = await masterService.getCityList(item);
    if (res.data.status === 200) {
      dispatch({
        type: CITY_LIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: CITY_LIST,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};

export const paymentTypes = (item) => async (dispatch) => {
  try {
 
    const res = await masterService.getMasterList(item);
   
    if (res.data.status === 200) {
      dispatch({
        type: PAYMENT_TYPE,
        payload: res.data,
      });
    } else {
      dispatch({
        type: PAYMENT_TYPE,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    errorToast(response.data.message);
  }
};

export const getEthnicity = () => async (dispatch) => {
  try {
    const res = await masterService.getMasterList({
      type: MasterTypeHelper.ethniCity,
    });
    if (res.data.status === 200) {
      dispatch({
        type: GET_ETHNICITY,
        payload: res.data,
      });
    } else {
      dispatch({
        type: GET_ETHNICITY,
        payload: [],
      });
    }
  } catch (e) {
    const { response = strings.initialError } = e;
    unAuthorizedError(response.data);
  }
};